import GLightbox from "glightbox";
import React, { useEffect } from "react";
import { FiPlay } from "react-icons/fi";
import data from "../data/appearances.json";
import { Markup } from "react-render-markup";

const Appear = ({isBg}) => {
  const { media } = data;
  useEffect(() => {
    GLightbox({
      selector: ".glightbox3",
    });
  }, []);

  return (
<div>
    {/* <section
      id="appearances"
      className={`section-padding ${isBg === "yes" ? "bg-one" : ""}`}
      style={{padding:"100px 0 0 0"}}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span></span>
              <h2 className="display-6">Appearances</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>

          </div>
    </section> */}
  

    <section id="about" className={`hero__padding  authorv3 ${isBg === "yes" ? "bg-one": "" }`}>
      <div className="container">
        <div className="row">
          <div
            className="col-md-3"
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-delay="300"
            data-aos-easing="ease-in-sine"
            style={{zIndex: 99, position: "relative"}}
          >
            <div className="author-image">
              <img className="img-fluid" src={media.image} alt="" />
            </div>
          </div>
          <div
            className="col-lg-9"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="authorv3__content">
              <div className="authorv3__content--badge">
                {/* {media.subtitle} */}
              </div>
              <h3 className="display-5 mb-2 mt-0">{media.title}</h3>
              <p className="m-30px-b text-muted fw-bold"><Markup markup={media.subtitle}/></p>
              <p className="m-30px-b"><Markup markup={media.description}/></p>
              <ul className="social-icon mt-0 mb-0">
                {media.social?.map((data, i) => (
                  <li key={i}>
                    {data.link === "" ? (
                      ""
                    ) : (
                      <a href={data.link}>
                        <img
                          className="img-fluid"
                          src={data.icon}
                          alt="icon"
                          width="25"
                          height="25"
                        />
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>


 <section
      className={`section-padding  ${isBg === "yes" ? "bg-one": "" }`}
      
    >
        <div className="container">
             
              <div className="row">
                
                {/* <!-- appear content start --> */}
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="200"
                >
                  <div className="author__content">
                    
                    <h2 className="m-20px-b">Talks</h2>
                    <p>
                      The messages and life lessons in Making it…or Not are ones to carry with you for a
lifetime, and so Amy’s talks with students delves deep into those messages, better
preparing them for the road ahead, whatever that looks like.
                    </p>
                    <h2 className="m-20px-b">Workshops</h2>
                    <h3>Primary:</h3>
                    <ol className="numlist m-30px-b">
                      <li>Preparing to write your own book
                        <ul className="numlist m-30px-b">

                          <li >Preparing for success                             
                          </li>
                          <li>Writers Habit Builder</li>
                          <li>It’s time to write</li>
                          <li>I’m ready to write my book!</li>
                          <li>Goal Tracker</li>

                      </ul>
                      </li>

                    </ol>
                    <h3>Secondary:</h3>
                    <ol className="numlist m-30px-b">
                      
                      <li>Motivational Speech</li>
                      <li>Q&A with the author</li>
                      <li>Trivia</li>

                    </ol>

                    <p>
                      For enquiries, bookings or event requests, please email amyschembri.author@gmail.com
                    </p>
                  </div>
                </div>
                {/* <!-- appear content start --> */}
              </div>
            </div>
    </section>

         
  
   
   


     
     </div>
  );
};

export default Appear;
